import { MediaMatcher } from '@angular/cdk/layout';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';

import { MatSidenav } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { AppConstant } from '@app/app.constants';

import { fadeAnimation } from './animations';
import { StorageMap } from '@ngx-pwa/local-storage';

@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.component.html',
  styleUrls: ['./public-layout.component.scss'],
  providers: [AppConstant],
  animations: [fadeAnimation]
})
export class PublicLayoutComponent implements OnInit {
  @ViewChild('sidenav') sidenav: MatSidenav | null = null;

  sidenavOpened = false;

  mobileQuery: MediaQueryList = this.mediaMatch.matchMedia(this.appConstant?.mobileResolution);

  @HostListener('window:resize')
  onResize() {
    this.mobileQuery = this.mediaMatch.matchMedia(this.appConstant?.mobileResolution);
  }

  get isSidenavOpened() {
    return this.sidenavOpened ? this.mobileQuery.matches : false;
  }

  constructor(private mediaMatch: MediaMatcher, private appConstant: AppConstant, private storage: StorageMap) {}

  ngOnInit() {
    this.storage.watch('theme').subscribe(newTheme => {
      // TODO for future use
    });
  }

  onToggleSidenav(sidenavOpened: boolean): void {
    this.sidenavOpened = sidenavOpened;
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet?.activatedRouteData['animation'];
  }
}
